<mat-progress-bar *ngIf="showLoader" style="margin-top: 2px;" class="col-md-12" mode="indeterminate"></mat-progress-bar>
<div *ngIf="blobUrl">
  <div class="btnpos">
    <button class="forsubmit schBtn button-right1" (click)="downloaddata()">Download</button>
  </div>
  <pdf-viewer [src]="safeurl?.changingThisBreaksApplicationSecurity" [original-size]="true" [zoom]="1.1"></pdf-viewer>
</div>
